import { type ReactNode, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { marsAuthApi } from "@/api/services/marsAuthService";
import { NoticeBar } from "@/components";
import { Icon } from "@/components/icon";
import LocalePicker from "@/components/locale-picker";
import type { NoticeItem } from "@/components/NoticeBar";
import { useSettings } from "@/store/settingStore";
// import { Button } from "@/ui/button";
import { cn } from "@/utils";
// import AccountDropdown from "../components/account-dropdown";
import BreadCrumb from "../components/bread-crumb";

// import NoticeButton from "../components/notice";
// import SearchBar from "../components/search-bar";
// import SettingButton from "../components/setting-button";

interface HeaderProps {
	leftSlot?: ReactNode;
}

export default function Header({ leftSlot }: HeaderProps) {
	const { t } = useTranslation();
	const { breadCrumb } = useSettings();
	const [noticeData, setNoticeData] = useState<NoticeItem[]>([]);
	const [defaultText] = useState("Welcome to FOMO Mining! 歡迎來到 FOMO 礦池！");

	useEffect(() => {
		const fetchLuckList = async () => {
			try {
				const res = await marsAuthApi.getTreasureLuckList();
				if (res.code === 0 && res.data.list.length > 0) {
					const items: NoticeItem[] = res.data.list.map((item) => ({
						id: item.poolId || Math.random(), // Use a unique key if available
						content: t("mining.notice.congratulations", {
							nickName: item.nickName || "User",
							amount: item.amount,
						}),
						type: item.type,
					}));
					setNoticeData(items);
				}
			} catch (error) {
				console.error("Failed to fetch luck list:", error);
			}
		};
		const timer = setInterval(
			() => {
				fetchLuckList();
			},
			1 * 60 * 1000,
		);
		fetchLuckList();
		return () => clearInterval(timer);
	}, [t]);

	return (
		<div className="sticky top-0 left-0 right-0 z-[999] flex flex-col">
			<header
				data-slot="slash-layout-header"
				className={cn(
					"flex items-center justify-between px-2 grow-0 shrink-0",
					"bg-background/60 backdrop-blur-xl",
					"h-[var(--layout-header-height)] ",
				)}
			>
				<div className="flex items-center">
					{leftSlot}

					<div className="hidden md:block ml-4">{breadCrumb && <BreadCrumb />}</div>
				</div>

				<div className="flex items-center gap-3">
					{/* <SearchBar /> */}
					{/* <LocalePicker /> */}
					{/* <Button
					variant="ghost"
					size="icon"
					className="rounded-full"
					onClick={() => window.open("https://github.com/d3george/slash-admin")}
				>
					<Icon icon="mdi:github" size={24} />
				</Button>
				<Button
					variant="ghost"
					size="icon"
					className="rounded-full"
					onClick={() => window.open("https://discord.gg/fXemAXVNDa")}
				>
					<Icon icon="carbon:logo-discord" size={24} />
				</Button>
				<NoticeButton />
				<SettingButton />
				<AccountDropdown /> */}
				</div>
			</header>
			<NoticeBar
				text={defaultText}
				data={noticeData}
				className=""
				icon={<Icon icon="mdi:bullhorn-outline" className="text-[#E6A23C] text-lg" />}
			/>
		</div>
	);
}
